/* Publish by EComposer at 2024-08-01 08:55:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-819eu91r5aj"]=  window.__ectimmers["ecom-819eu91r5aj"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-819eu91r5aj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-819eu91r5aj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qctc6txt4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qctc6txt4h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pggh712pvv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pggh712pvv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7u8vd1rojgv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7u8vd1rojgv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9g4rze6be').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9g4rze6be', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pj8jo0yp76a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pj8jo0yp76a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-az478jvwmub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-az478jvwmub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pcw0vsvgbwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pcw0vsvgbwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wje5dzfbwzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wje5dzfbwzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqmgc9azmi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqmgc9azmi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqd4qljp5yc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqd4qljp5yc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3mwxgx10sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3mwxgx10sr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jemyidl2yye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jemyidl2yye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmd5f5r1vau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmd5f5r1vau', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71pq0g42zrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71pq0g42zrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-udlem68ot9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udlem68ot9l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yaatl1jsar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yaatl1jsar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9d8qwmpwvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9d8qwmpwvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-911qw5nw9ww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-911qw5nw9ww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aj66f4j5pou').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aj66f4j5pou', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fltzccd3gdt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fltzccd3gdt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqq9v3xz8ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqq9v3xz8ab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugg4uytz5ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugg4uytz5ob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7wcdbgvmb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7wcdbgvmb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qag9swxbuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qag9swxbuh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbth0p55ih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbth0p55ih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nl4srcz6q6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nl4srcz6q6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dlfxxk66heu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dlfxxk66heu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9p3wzva9m6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9p3wzva9m6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ps0b3ofq5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ps0b3ofq5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0czglryuoxdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0czglryuoxdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5oxm1yxef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5oxm1yxef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8cpdkbvne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8cpdkbvne', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nkdw523o5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkdw523o5v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvg3ben6v3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvg3ben6v3s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ldc2gi79v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ldc2gi79v8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lft41wc37kc"]=  window.__ectimmers["ecom-lft41wc37kc"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-lft41wc37kc"]["lox44a5ih"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-lft41wc37kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lft41wc37kc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fka07g9kgqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fka07g9kgqs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jel8tuqflq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jel8tuqflq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahbq9vjzmcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahbq9vjzmcn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fza0a9llud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fza0a9llud', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q79wot2m7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q79wot2m7h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fg6plnskdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fg6plnskdg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jsjo501iddn"]=  window.__ectimmers["ecom-jsjo501iddn"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;i.forEach((a,r)=>{n==="click"||window.screen.width<1025?a.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}:a.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}});function s(){let a=window.location.hash;if(a){let r=e.querySelector(`[data-target="${a}"]`);if(r){r.click();let l=r.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,l)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-jsjo501iddn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsjo501iddn', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w355jb6m4gq"]=  window.__ectimmers["ecom-w355jb6m4gq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-w355jb6m4gq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w355jb6m4gq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he1ie8crblm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he1ie8crblm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kaakzgdqvkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kaakzgdqvkp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xdu1jm2auw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xdu1jm2auw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sqwvzoi3n9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sqwvzoi3n9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnj6hycr7q8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnj6hycr7q8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bzjmyytjxp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bzjmyytjxp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3atcwptc5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3atcwptc5g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7p80ngqxh4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7p80ngqxh4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yavbkasoyz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yavbkasoyz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aaazm5044m5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aaazm5044m5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wyqif4i0weo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wyqif4i0weo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06v91m9iiyxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06v91m9iiyxd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pvu1hsoolk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pvu1hsoolk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewbhkn6gr5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewbhkn6gr5s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkk7rognawm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkk7rognawm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mg61elkdzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mg61elkdzh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2aml9eha3jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2aml9eha3jj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o12b4x8gh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o12b4x8gh8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywp7qq2kkz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywp7qq2kkz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubg3mq57r6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubg3mq57r6s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dcc4ke4xf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dcc4ke4xf4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxj2s2eiccg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxj2s2eiccg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9929u764lki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9929u764lki', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jescwoftod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jescwoftod', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4dqc26d06m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4dqc26d06m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7v4i999lgat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7v4i999lgat', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppjhsm5mpnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppjhsm5mpnn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p8myb5hhjvh"]=  window.__ectimmers["ecom-p8myb5hhjvh"] || {};
if(!this.$el)return;const e=this.$el,i=this,c=this.settings.layout;let l=e.closest(".core__row--columns");const n=e.querySelector(".ecom-shopify__menu-list--mobile"),s=e.querySelector(".ecom-menu__icon-humber"),m=e.querySelector(".ecom-menu-collapse-close--mobile");let u=e.closest("div.ecom-core.core__block")||"",d=e.closest("div.ecom-column.ecom-core")||"",y=e.querySelectorAll(".ecom-shopify__menu-item--link");for(u&&(u.style.overflow="visible"),y&&n&&y.forEach(function(t){t.addEventListener("click",function(){g()})}),s&&(s.addEventListener("click",v),m.addEventListener("click",g));l;)l.style.zIndex="100",l=l.parentElement.closest(".core__row--columns");function v(){!n||(n.parentNode.style.display="block",n.classList.add("ecom-show"),u&&(u.style.zIndex="100"),d&&(d.style.zIndex="100"),document.querySelector("body").classList.add("ecom-menu-opened"),setTimeout(function(){document.addEventListener("click",p),document.addEventListener("keydown",f)},500))}function p(t){let a=t.target;do{if(a==n)return;a=a.parentNode}while(a);a!=n&&(g(),document.removeEventListener("click",p),document.removeEventListener("keydown",f))}function f(t){(t.isComposing||t.keyCode===27)&&(g(),document.removeEventListener("keydown",f),document.removeEventListener("click",p))}function g(){n.parentNode.style.display="none",n.classList.remove("ecom-show"),u&&(u.style.zIndex="1"),d&&(d.style.zIndex="1"),document.querySelector("body").classList.remove("ecom-menu-opened"),document.removeEventListener("keydown",f),document.removeEventListener("click",p)}let z=e.querySelector('.ecom-shopify__menu-list[data-menu-layout="horizontal"]'),k=null;z&&(k=z.querySelectorAll(".ecom-shopify__menu-item--has-children>.ecom-menu_item>.ecom-element--menu_title")),k&&k.forEach(function(t){t.addEventListener("click",function(a){a.preventDefault()})});function S(){var t=e.querySelectorAll(".ecom-shopify__menu-list .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"),a=e.querySelectorAll(".ecom-shopify__menu-list--mobile .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list--mobile .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item");if(!!t){var r,b="false",w=e.querySelector(".ecom-shopify__menu-wrapper");if(w&&w.dataset.showAll)var b=w.dataset.showAll;for(r=0;r<t.length;r++){let x=function(o){let _=o.nextElementSibling,h=null;if(o.classList.contains("ecom-item-active")){if(o.classList.remove("ecom-item-active"),_){_.style.maxHeight=null;var $=_.querySelectorAll(".ecom-menu_item");$&&$.forEach(L=>{var E=L.nextElementSibling;E&&(E.style.maxHeight=null),L.classList.remove("ecom-item-active")}),h=o.closest(".ecom-shopify__menu-sub-menu"),h&&(h.style.maxHeight=parseInt(h.style.maxHeight)-_.scrollHeight+"px")}}else o.classList.add("ecom-item-active"),_&&(h=o.closest(".ecom-shopify__menu-sub-menu"),h&&(h.style.maxHeight=parseInt(h.style.maxHeight)+_.scrollHeight+"px"),_.style.maxHeight=_.scrollHeight+"px")};c==="horizontal"&&!i.isLive?t[r].addEventListener("click",function(o){o.preventDefault()}):c==="horizontal"&&i.isLive?t[r].addEventListener("click",function(o){o.stopPropagation()}):(c==="vertical"||!i.isLive)&&(b&&b=="true"&&x(t[r]),t[r].addEventListener("click",function(o){o.preventDefault(),x(this)})),a[r]&&a[r].addEventListener("click",function(o){o.preventDefault(),x(this)})}}}S()

                    });
                    
                        document.querySelectorAll('.ecom-p8myb5hhjvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8myb5hhjvh', settings: {"layout":"horizontal"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}